import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { InvoiceStatus } from "../enums";
import { IAPIInvoiceGridModel } from "../interfaces";
import { ContactReferenceModel } from "./ContactDetailPageModel";

 
 
export class InvoiceGridModel {
    public id: string;
    public dueDate: Date;
    public status: keyof typeof InvoiceStatus;
    public invoiceNumber: string;
    public amount: number;
    public paidAmount: number;
    public balance: number;
    public pastDueDays: number;
    public contact: ContactReferenceModel;
    public isPayPopUpAllowed: boolean;
    constructor(data: Partial<InvoiceGridModel> = {}) {
        this.id = data.id || '';
        this.dueDate = data.dueDate || new Date();
        this.status = data.status || 'Open';
        this.invoiceNumber = data.invoiceNumber || '';
        this.paidAmount = data.paidAmount || 0;
        this.amount = data.amount || 0;
        this.balance = data.balance || 0;
        this.pastDueDays = data.pastDueDays || 0;
        this.contact = data.contact || new ContactReferenceModel();
        this.isPayPopUpAllowed =
            (this.status === 'Open' || this.status === 'PastDue' || this.status === InvoiceStatus.Uncollectible) &&
            this.balance > 0;
    }

    static deserializeAPIModel(data: IAPIInvoiceGridModel): InvoiceGridModel {
        const mappedData: Partial<InvoiceGridModel> = {
            id: data.id,
            dueDate: UtilityMethods.removeZFromDateString(data.dueDate),
            status: data.status,
            invoiceNumber: data.invoiceNumber,
            amount: data.amount,
            paidAmount: data.paidAmount,
            balance: data.balance,
            pastDueDays: data.pastDueDays,
            contact: ContactReferenceModel.deserializeAPIModel(data.contact),
        };
        return new InvoiceGridModel(mappedData);
    }
}
